import type { FC, ReactNode } from 'react'

import { Header } from '@/components/site/header'
import { Footer } from '@/components/site/footer'

interface SiteLayoutProps {
    children: ReactNode
    tone?: 'light' | 'dark'
}

export const Layout: FC<SiteLayoutProps> = ({ children, tone = 'light' }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col bg-background'>
            <Header tone={tone} />

            <main id='main' className='flex-1'>
                {children}
            </main>

            <Footer />
        </div>
    )
}
